/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Doc_Mental_Health_AriaInputs */

const en_faq_doc_mental_health_aria = /** @type {(inputs: Faq_Doc_Mental_Health_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Mental Health Guide Document`)
};

const fr_faq_doc_mental_health_aria = /** @type {(inputs: Faq_Doc_Mental_Health_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers le document Guide de santé mentale`)
};

/**
* | output |
* | --- |
* | "Link to Mental Health Guide Document" |
*
* @param {Faq_Doc_Mental_Health_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const faq_doc_mental_health_aria = /** @type {((inputs?: Faq_Doc_Mental_Health_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Doc_Mental_Health_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_doc_mental_health_aria(inputs)
	return fr_faq_doc_mental_health_aria(inputs)
});